import React from "react";
import ReactNativeModal from "react-native-modal";
import { Image, Pressable } from "react-native";
import { useChatMetadata } from "./chat-metadata-provider";
import CloseIcon from "@/assets/svgs/close-icon";
import ResponsiveContent from "../shared/responsive-content";
import { useIsFocused } from "@react-navigation/native";

function ChatImagePreview() {
  const { chatMetadata, setChatMetadata } = useChatMetadata();
  const imageUrl = chatMetadata?.selectedImageUrl;
  const isVisible = !!imageUrl;
  const isFocussed = useIsFocused();

  return (
    <ReactNativeModal
      isVisible={isVisible && isFocussed}
      style={{ margin: 0 }}
    >
      <ResponsiveContent className="flex-1">
        <Image
          source={{ uri: imageUrl }}
          className="w-full h-full"
          resizeMode="contain"
        />
      </ResponsiveContent>
      <Pressable
        className="absolute top-10 right-10"
        onPress={() => setChatMetadata({ selectedImageUrl: undefined })}
      >
        <CloseIcon className="size-6" />
      </Pressable>
    </ReactNativeModal>
  );
}

export default ChatImagePreview;
